import Header from './components/Header';
import Footer from './components/Footer';
import About from './pages/About';
import NotFound from './pages/NotFound';
import {Route,Routes,BrowserRouter as Router,useNavigate, Navigate} from 'react-router-dom';
import {useState,useEffect} from 'react'
import api from './api/accesstokenrouterapi';
import LoginUI from './pages/LoginUI';
import LogOutUI from './pages/LogOutUI';
import ProtectedRoute from './ProtectedRoute';
import Spinner from 'react-bootstrap/Spinner';

import MoreOptions from './pages/MoreOptions';


import NavAdmin from './components/NavAdmin';
import UserNav from './components/UserNav';
import HomeAdmin from './pages/HomeAdmin';
import ReceivedForms from './pages/ReceivedForms';

import RegistrationForm from './pages/RegistrationForm';
import AddPeoplePage from './pages/AddPeoplePage';
import AllPeople from './pages/AllPeople';
import EditPeoplePage from './pages/EditPeoplePage';

import AllEvents from './pages/AllEvents';
import AddEventPage from './pages/AddEventPage';
import EditEventPage from './pages/EditEventPage';



function App() {    
  const [isAuthenticated,setIsAuthenticated]=useState(false); 
  const [isAppLoaded,setIsAppLoaded]=useState(true); 
  const [refreshFailed,setRefreshFailed]=useState(true);
  const [accessToken,setAccessToken]=useState(''); 
  const [loginType,setLoginType]=useState('');
  const [fullName,setFullName]=useState('');
  useEffect(()=>{
    const fetchAT=async ()=>{
          try{
            const config = { withCredentials: true };
            const x=await api.get('/getAccessToken',config);      
             
            const nat=x['data']['accessToken'];
            const ufn=x['data']['userFullName'];
            const un=x['data']['userName'];
            const lt=x['data']['loginType'];
            setAccessToken(nat);    
            setLoginType(lt);     
            setIsAuthenticated(true);   
            setRefreshFailed(false); 
            setFullName(x['data']['userFullName']);
            }
            catch(err)
            {
              //alert('app load error');
              setAccessToken('');   
              setLoginType('');   
              setIsAuthenticated(false);  
              setRefreshFailed(true);              
            }
            finally
            {
              setIsAppLoaded(true);
              //alert('app loaded'+accessToken);
            }
    }
    fetchAT();
  },[refreshFailed]);
  return (   
    
      <Router>
        <div className="App">
        {<Header></Header>}
          { (isAppLoaded)&&!refreshFailed &&(loginType.toLowerCase()==="admin")&& <NavAdmin
            />}
            { (isAppLoaded)&&refreshFailed&& <UserNav
            />
            }

          { (isAppLoaded) &&!refreshFailed &&(loginType.toLowerCase()==="admin")&&
            <>
            <Routes>
              <Route element={<ProtectedRoute isAuthenticated={isAuthenticated}/>}>
                  <Route  path='/' element={<HomeAdmin                        
                             fullName={fullName}
                            />}>            
                  </Route>  

                  <Route  path='/submittedforms' element={<ReceivedForms                        
                            accessToken={accessToken} 
                            setAccessToken={setAccessToken}
                            setRefreshFailed={setRefreshFailed}
                            />}>            
                  </Route>  

                  <Route path='/registrationform/:form_id' element={<RegistrationForm
                          accessToken={accessToken} 
                          setAccessToken={setAccessToken}
                          setRefreshFailed={setRefreshFailed}
                          />}> 
                  </Route> 

                  <Route  path='/allpeople' element={<AllPeople                        
                            accessToken={accessToken} 
                            setAccessToken={setAccessToken}
                            setRefreshFailed={setRefreshFailed}
                            />}>            
                  </Route>  
                  <Route  path='/addpeople' element={<AddPeoplePage                        
                            accessToken={accessToken} 
                            setAccessToken={setAccessToken}
                            setRefreshFailed={setRefreshFailed}
                            />}>            
                  </Route>  
                  <Route  path='/editpeople/:form_id' element={<EditPeoplePage                        
                            accessToken={accessToken} 
                            setAccessToken={setAccessToken}
                            setRefreshFailed={setRefreshFailed}
                            />}>            
                  </Route>  
                  <Route  path='/allevents' element={<AllEvents                        
                            accessToken={accessToken} 
                            setAccessToken={setAccessToken}
                            setRefreshFailed={setRefreshFailed}
                            />}>            
                  </Route> 
                  <Route  path='/addevent' element={<AddEventPage                        
                            accessToken={accessToken} 
                            setAccessToken={setAccessToken}
                            setRefreshFailed={setRefreshFailed}
                            />}>            
                  </Route>  

                  <Route  path='/editevent/:form_id' element={<EditEventPage                        
                            accessToken={accessToken} 
                            setAccessToken={setAccessToken}
                            setRefreshFailed={setRefreshFailed}
                            />}>            
                  </Route>  
                  <Route path='/moreoptions' element={<MoreOptions
                            />}> 
                  </Route>
                  
                  
              </Route>
          
          
              <Route  path='/about' element={<About></About>}></Route>
              <Route path='*' element={<NotFound></NotFound>}></Route>

              <Route  path='/login' element={!isAuthenticated? <LoginUI
                    setRefreshFailed={setRefreshFailed} setGlobalLoginType={setLoginType} setAccessToken={setAccessToken} setIsAuthenticated={setIsAuthenticated}/>:<Navigate to="/" />}>            
              </Route>
              <Route  path='/logout' element={isAuthenticated? <LogOutUI
              setAccessToken={setAccessToken} setIsAuthenticated={setIsAuthenticated} setLoginType={setLoginType} setRefreshFailed={setRefreshFailed}/>:<Navigate to="/Login" />}>            
              </Route>
            </Routes>
            </>
          }
        {
          !isAppLoaded &&
            <div className='spinnerovsetSeerlay'>
              <div className='spinnerbody'>
                <Spinner animation="border" variant="info" />
                <p>Please wait. It might take a few seconds.</p>
              </div>           
            </div>
        }
        {
        (isAppLoaded) && refreshFailed && 
          <>
          <Routes>
          <Route  path='/about' element={<About></About>}></Route>
            <Route path='*' element={ <LoginUI
                  setGlobalLoginType={setLoginType} setRefreshFailed={setRefreshFailed} setAccessToken={setAccessToken} setIsAuthenticated={setIsAuthenticated}/>}>            
                  </Route>

            <Route  path='/login' element={ <LoginUI
                  setGlobalLoginType={setLoginType} setRefreshFailed={setRefreshFailed}   setAccessToken={setAccessToken} setIsAuthenticated={setIsAuthenticated}/>}>            
            </Route>
            <Route  path='/logout' element={ <LogOutUI
            setAccessToken={setAccessToken} setIsAuthenticated={setIsAuthenticated} setRefreshFailed={setRefreshFailed}/>}>            
            </Route>
          </Routes>
          </>
        }

          <Footer></Footer>
        </div>
      </Router>
  );
}

export default App;
